<template>
  <div>
    <b-modal
      id="download-rincian-saldo"
      size="md"
      centered
      hide-header
      hide-footer
    >
      <div class="text-black text-20-bold mb-1">
        Download Rincian Saldo
      </div>
      <div class="text-black text-lg mb-2">
        Kustomisasi rincian saldo yang ingin kamu download
      </div>
      <div class="text-black text-lg mb-1">
        Pilih Rentang
      </div>
      <div>
        <date-range-picker
          ref="picker"
          v-model="dateRangeDownload"
          :locale-data="locale"
          :ranges="rangesDownload"
          :max-date="today"
          :opens="'left'"
          class="w-100"
        >
          <template
            style="min-width: 350px"
          >
            <div
              class="d-flex justify-content-between align-items-center w-100 pt-50"
            >
              <div>
                <img
                  src="https://storage.googleapis.com/komerce/assets/icons/date-picker-icon.svg"
                >
              </div>
            </div>
          </template>
        </date-range-picker>
        <small
          v-if="isExceedMaxDays"
          class="text-danger d-block mt-50"
        >
          Maksimal rentang tanggal adalah 60 hari
        </small>
      </div>
      <div class="d-flex justify-content-between mt-2 gap-2">
        <div class="w-50">
          <b-button
            variant="outline-primary"
            block
            @click="closeModal"
          >
            Batal
          </b-button>
        </div>
        <div class="w-50">
          <b-button
            variant="primary"
            block
            :disabled="isExceedMaxDays || downloadStatus === 'loading'"
            @click="downloadDetailSaldo"
          >
            <b-spinner
              v-if="downloadStatus === 'loading'"
              class="mr-1"
              small
              variant="light"
            />
            Download
          </b-button>
        </div>
      </div>
    </b-modal>

    <ModalStatusDownload
      :status="downloadStatus"
      @on-action="handleModalAction"
    />
  </div>
</template>
<script>
import DateRangePicker from 'vue2-daterange-picker'
import {
  today,
  last7,
  last30,
  last60,
  kompackDate,
} from '@/store/helpers'
import { YEAR_MONTH_DAY } from '@/libs/formatDate'

import ModalStatusDownload from './ModalStatusDownload.vue'

export default {
  name: 'DownloadRincianSaldo',
  components: {
    DateRangePicker,
    ModalStatusDownload,
  },
  data() {
    return {
      downloadStatus: '',
      dateRangeDownload: {
        startDate: today,
        endDate: today,
      },
      locale: {
        format: 'dd/mm/yyyy',
        daysOfWeek: ['Min', 'Sen', 'Sel', 'Rab', 'Kam', 'Jum', 'Sab'],
        monthNames: ['Jan', 'Feb', 'Mar', 'Apr', 'Mei', 'Jun', 'Jul', 'Agu', 'Sep', 'Okt', 'Nov', 'Des'],
      },
      rangesDownload: {
        'Hari Ini': [today, today],
        '7 Hari Terakhir': [last7, today],
        '30 Hari Terakhir': [last30, today],
        'Custom Tanggal': [null, null],
      },
      today,
      last7,
      last30,
      last60,
      kompackDate,
    }
  },
  computed: {
    isExceedMaxDays() {
      if (!this.dateRangeDownload?.startDate || !this.dateRangeDownload?.endDate) return false
      const start = new Date(this.dateRangeDownload.startDate)
      const end = new Date(this.dateRangeDownload.endDate)
      const diffTime = Math.abs(end - start)
      const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24))
      return diffDays > 60
    },
  },
  methods: {
    closeModal() {
      this.$bvModal.hide('download-rincian-saldo')
    },
    handleModalAction() {
      this.$bvModal.hide('modal-status-download')
    },
    saveBase64File(base64) {
      const bytes = Uint8Array.from(atob(base64), c => c.charCodeAt(0))
      const blob = new Blob([bytes], { type: 'application/vnd.ms-excel' })
      const url = URL.createObjectURL(blob)
      const a = Object.assign(document.createElement('a'), {
        href: url,
        download: `Rincian_Saldo_Partner_${YEAR_MONTH_DAY(this.dateRangeDownload.startDate)}_${YEAR_MONTH_DAY(this.dateRangeDownload.endDate)}.xlsx`,
      })
      a.click()
      URL.revokeObjectURL(url)
    },
    downloadDetailSaldo() {
      if (this.isExceedMaxDays) return
      this.closeModal()
      this.downloadStatus = 'loading'
      this.$bvModal.show('modal-status-download')

      this.$http_new
        .get('/auth/api/v1/partner/print/transaction-balance', {
          params: {
            start_date: YEAR_MONTH_DAY(this.dateRangeDownload.startDate),
            end_date: YEAR_MONTH_DAY(this.dateRangeDownload.endDate),
          },
        })
        .then(response => {
          const { data, code = 200 } = response.data || {}

          if (code === 422) {
            this.downloadStatus = 'queue'
          } else if (code !== 200) {
            this.downloadStatus = 'error'
          } else if (typeof data === 'string' && data) {
            this.saveBase64File(data)
            this.downloadStatus = 'device'
          } else if (Array.isArray(data)) {
            this.downloadStatus = 'empty'
          } else if (data == null) {
            this.downloadStatus = 'email'
          } else {
            this.downloadStatus = 'error'
          }
        })
        .catch(err => {
          const status = err.response?.status || err.response?.data?.code
          this.downloadStatus = status === 422 ? 'queue' : 'error'
        })
    },
  },
}
</script>
